/**
 * Audit Log API Service
 * Handles all audit log related API calls
 */
class AuditLogApi {
    /**
     * Get paginated audit logs with filtering
     * @param {Object} params - Query parameters (page, pageSize, userId, eventType, severity, startDate, endDate, etc.)
     */
    getList(params = {}) {
        const queryParams = new URLSearchParams();

        // Add all provided parameters to query string
        Object.keys(params).forEach(key => {
            if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
                queryParams.append(key, params[key]);
            }
        });

        const url = `${apiUrl}AuditLogs?${queryParams.toString()}`;
        return api.call('get', url)
            .then(({ data }) => {
                return data;
            });
    }

    /**
     * Get single audit log by ID with full details
     * @param {string} id - Audit log ID
     */
    get(id) {
        const url = `${apiUrl}AuditLogs/${id}`;
        return api.call('get', url)
            .then(({ data }) => {
                return data;
            });
    }

    /**
     * Get audit statistics
     * @param {number} days - Number of days for statistics (default: 7)
     */
    getStatistics(days = 7) {
        const url = `${apiUrl}AuditLogs/statistics?days=${days}`;
        return api.call('get', url)
            .then(({ data }) => {
                return data;
            });
    }

    /**
     * Get audit trail for a specific entity
     * @param {string} entityType - Entity type (e.g., 'Stock', 'Customer')
     * @param {string} entityId - Entity ID
     */
    getEntityAuditTrail(entityType, entityId) {
        const url = `${apiUrl}AuditLogs/entity/${entityType}/${entityId}`;
        return api.call('get', url)
            .then(({ data }) => {
                return data;
            });
    }

    /**
     * Cleanup old audit logs
     * @param {number} retentionDays - Retention period in days (minimum 30)
     */
    cleanup(retentionDays = 90) {
        const url = `${apiUrl}AuditLogs/cleanup?retentionDays=${retentionDays}`;
        return api.call('post', url)
            .then(({ data }) => {
                return data;
            });
    }
}

export default AuditLogApi;
